import React from 'react';
import PropTypes from 'prop-types';
import Media from './Media';
import MediaSkeleton, {
	MediaSkeletonContainerClasses
} from '../skeleton/MediaSkeleton';
import { useCompareOverImage } from '../../../hooks';

const MediaContainer = ({
	shouldFullyRenderCard,
	vehicle,
	willRenderBlankPlaceholderImage,
	...props
}) => {
	const compareOverImage = useCompareOverImage();

	const shouldShowCompareOverImage =
		shouldFullyRenderCard &&
		!willRenderBlankPlaceholderImage &&
		compareOverImage;

	const mediaContent = shouldFullyRenderCard ? (
		<Media
			{...props}
			vehicle={vehicle}
			willRenderBlankPlaceholderImage={willRenderBlankPlaceholderImage}
			shouldShowCompareOverImage={shouldShowCompareOverImage}
		/>
	) : (
		<MediaSkeleton />
	);

	return (
		<div
			className={`vehicle-card-media-container${
				!shouldFullyRenderCard
					? ` ${MediaSkeletonContainerClasses.join(' ')}`
					: ''
			}`}
		>
			{mediaContent}
		</div>
	);
};

MediaContainer.propTypes = {
	shouldFullyRenderCard: PropTypes.bool.isRequired,
	vehicle: PropTypes.shape({
		uuid: PropTypes.string
	}),
	willRenderBlankPlaceholderImage: PropTypes.bool
};

export default MediaContainer;
